import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import styles from './CustomMenuButton.module.scss';

type Props = {
  label: string;
  to?: string;
  onClick?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  tabIndex?: number;
  active?: boolean;
  startIcon?: React.ReactElement;
  dashboard?: boolean;
  small?: boolean;
  target?: string;
  rel?: string;
} & React.AriaAttributes;

const CustomMenuButton: React.FC<Props> = ({
  label,
  to,
  onClick,
  onBlur,
  onFocus,
  tabIndex = 0,
  active = false,
  startIcon,
  dashboard = false,
  small = false,
  target,
  rel,
  ...rest
}: Props) => {
  const icon = startIcon ? <div className={dashboard ? styles.startIcon_dashboard : styles.startIcon}>{startIcon}</div> : null;

  const buttonClass = classNames(styles.menuButton, {
    [styles.small]: small,
    [styles.active]: active,
  });

  const buttonContent = (
    <>
      {icon}
      <span className={styles.label}>{label}</span>
    </>
  );

  const isExternal = to && /^https?:\/\//.test(to);

  if (to) {
    if (isExternal) {
      return (
        <a href={to} target={target} rel={rel} onBlur={onBlur} onFocus={onFocus} onClick={onClick} className={buttonClass} tabIndex={tabIndex} {...rest}>
          {buttonContent}
        </a>
      );
    }
  }

  if (to) {
    return (
      <NavLink
        to={to}
        onBlur={onBlur}
        onFocus={onFocus}
        onClick={onClick}
        className={({ isActive }) => classNames(buttonClass, { [styles.active]: isActive })}
        tabIndex={tabIndex}
        end
        {...rest}
      >
        {buttonContent}
      </NavLink>
    );
  }

  return (
    <div role="button" onBlur={onBlur} onFocus={onFocus} onClick={onClick} className={buttonClass} tabIndex={tabIndex} {...rest}>
      {buttonContent}
    </div>
  );
};

export default CustomMenuButton;
